"use strict";
import $ from "jquery";
import React from "react";
import ReactDOM from "react-dom";
import _ from "underscore";
import moment from "moment";
window.$ = window.jQuery = $;
global.React = React;
global.ReactDOM = ReactDOM;
global._ = _;
global.moment = moment;
